import { HttpErrorResponse } from '@angular/common/http';
import { DataSeries } from '@next/core-lib/models';
import { createAction, props } from '@ngrx/store';
import { UnitOfMeasureSettings } from 'src/app/settings/models/setting.model';

import { ObservationsRegistration } from '../../models/within-cycle-performance.model';

/* tslint:disable: max-classes-per-file */
export const loadRefValSheetDataSeriesRequest = createAction(
  '[WithinCyclePerformance] Load RefValSheet DataSeries request',
  props<{ id: number }>(),
);
export const loadRefValSheetDataSeriesSuccess = createAction(
  '[WithinCyclePerformance] Load RefValSheet DataSeries success',
  props<{ refValSheetDataSeries: DataSeries<number, number> }>(),
);
export const loadRefValSheetDataSeriesError = createAction(
  '[WithinCyclePerformance] Load RefValSheet DataSeries error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadWdoDataSeriesRequest = createAction(
  '[WithinCyclePerformance] Load WDO DataSeries request',
  props<{ cycleId: number; barnIds: number[] }>(),
);
export const loadWdoDataSeriesSuccess = createAction(
  '[WithinCyclePerformance] Load WDO DataSeries success',
  props<{ wdoDataSeries: DataSeries<number, number>[] }>(),
);
export const loadWdoDataSeriesError = createAction(
  '[WithinCyclePerformance] Load WDO DataSeries error',
  props<{ error: HttpErrorResponse }>(),
);

export const loadObservationsForCycleRequest = createAction(
  '[WithinCyclePerformance] Load observations for cycle request',
  props<{ cycleId: number; unitOfMeasureSettings: UnitOfMeasureSettings }>(),
);

export const loadObservationsForCycleSuccess = createAction(
  '[WithinCyclePerformance] Load observations for cycle success',
  props<{ observations: ObservationsRegistration[] }>(),
);

export const loadObservationsForCycleFailed = createAction(
  '[WithinCyclePerformance] Load observations for cycle failed',
  props<{ error: Error }>(),
);

export const upsertObservationsForCycleRequest = createAction(
  '[WithinCyclePerformance] Upsert observations for cycle request',
  props<{
    observations: ObservationsRegistration[];
    unitOfMeasureSettings: UnitOfMeasureSettings;
  }>(),
);

export const upsertObservationsForCycleSuccess = createAction(
  '[WithinCyclePerformance] Upsert observations for cycle success',
  props<{ observations: ObservationsRegistration[] }>(),
);

export const upsertObservationsForCycleFailed = createAction(
  '[WithinCyclePerformance] Upsert observations for cycle failed',
  props<{ error: Error }>(),
);

export const loadGrowthPredictionDataSeriesRequest = createAction(
  '[WithinCyclePerformance] Load GrowthPrediction DataSeries request',
  props<{ cycleId: number; barnIds: number[] }>(),
);
export const loadGrowthPredictionDataSeriesSuccess = createAction(
  '[WithinCyclePerformance] Load GrowthPrediction DataSeries success',
  props<{ growthPredictionDataSeries: DataSeries<number, number>[] }>(),
);
export const loadGrowthPredictionDataSeriesError = createAction(
  '[WithinCyclePerformance] Load GrowthPrediction DataSeries error',
  props<{ error: HttpErrorResponse }>(),
);
